/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionAuditActorOptionData } from './SubscriptionAuditActorOptionData';
import {
    SubscriptionAuditActorOptionDataFromJSON,
    SubscriptionAuditActorOptionDataFromJSONTyped,
    SubscriptionAuditActorOptionDataToJSON,
    SubscriptionAuditActorOptionDataToJSONTyped,
} from './SubscriptionAuditActorOptionData';
import type { SubscriptionAuditAdminRowData } from './SubscriptionAuditAdminRowData';
import {
    SubscriptionAuditAdminRowDataFromJSON,
    SubscriptionAuditAdminRowDataFromJSONTyped,
    SubscriptionAuditAdminRowDataToJSON,
    SubscriptionAuditAdminRowDataToJSONTyped,
} from './SubscriptionAuditAdminRowData';

/**
 * 
 * @export
 * @interface SubscriptionAuditAdminPageData
 */
export interface SubscriptionAuditAdminPageData {
    /**
     * 
     * @type {Array<SubscriptionAuditAdminRowData>}
     * @memberof SubscriptionAuditAdminPageData
     */
    items?: Array<SubscriptionAuditAdminRowData>;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionAuditAdminPageData
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionAuditAdminPageData
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionAuditAdminPageData
     */
    total?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubscriptionAuditAdminPageData
     */
    sources?: Array<string>;
    /**
     * 
     * @type {Array<SubscriptionAuditActorOptionData>}
     * @memberof SubscriptionAuditAdminPageData
     */
    actors?: Array<SubscriptionAuditActorOptionData>;
}

/**
 * Check if a given object implements the SubscriptionAuditAdminPageData interface.
 */
export function instanceOfSubscriptionAuditAdminPageData(value: object): value is SubscriptionAuditAdminPageData {
    return true;
}

export function SubscriptionAuditAdminPageDataFromJSON(json: any): SubscriptionAuditAdminPageData {
    return SubscriptionAuditAdminPageDataFromJSONTyped(json, false);
}

export function SubscriptionAuditAdminPageDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionAuditAdminPageData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(SubscriptionAuditAdminRowDataFromJSON)),
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'total': json['total'] == null ? undefined : json['total'],
        'sources': json['sources'] == null ? undefined : json['sources'],
        'actors': json['actors'] == null ? undefined : ((json['actors'] as Array<any>).map(SubscriptionAuditActorOptionDataFromJSON)),
    };
}

export function SubscriptionAuditAdminPageDataToJSON(json: any): SubscriptionAuditAdminPageData {
    return SubscriptionAuditAdminPageDataToJSONTyped(json, false);
}

export function SubscriptionAuditAdminPageDataToJSONTyped(value?: SubscriptionAuditAdminPageData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(SubscriptionAuditAdminRowDataToJSON)),
        'page': value['page'],
        'pageSize': value['pageSize'],
        'total': value['total'],
        'sources': value['sources'],
        'actors': value['actors'] == null ? undefined : ((value['actors'] as Array<any>).map(SubscriptionAuditActorOptionDataToJSON)),
    };
}

